import { useMemo } from 'react';
import { useGet } from '@ngt/forms';
import { GetAppSettings, GetAppSettingsResponse } from '@/api/dtos';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<GetAppSettingsResponse, GetAppSettingsResponse>) => response?.data;
const getError = (response?: SWRResponse<GetAppSettingsResponse, GetAppSettingsResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useAppSettings = ( configuration: SWRConfiguration = { 
}) => {
    const request = useMemo(() => {

        return () => {
            return new GetAppSettings({});
        }
    }, []);

    return useGet(request, { getData, getError }, configuration)
}

export default useAppSettings;
